import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location){
  return originalPush.call(this,location).catch(err=>err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '巨象首页'
          },

        },

        {
          path: '/newsMore',
          name: 'newsMore',
          component: resolve => require(['@/view/newsMore'], resolve),
        },

        {
          path: '/newsDetail/:id',
          name: 'newsDetail',
          component: resolve => require(['@/view/newsDetail'], resolve),
        },

        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: resolve => require(['@/view/aboutUs'], resolve),
          meta: {
            title: '关于我们'
          },
          children: [
            {
              path: '/software/:id',
              redirect: '/software/smartTown/:id'
            },
            {
              path: '/software/smartTown/:id',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        },

        {
          path: '/download',
          name: 'download',
          component: resolve => require(['@/view/download'], resolve),
          meta: {
            title: '下载中心'
          },
        }, 
        {
          path: '/deepseek',
          name: '智联灵犀Ai',
          component: resolve => require(['@/view/deepseek'], resolve),
          meta: {
            title: '智联灵犀Ai'
          },
        },{
          path: '/workShopLogin',
          name: 'workShopLogin',
          component: resolve => require(['@/view/workShopLogin'], resolve),
          meta: {
            title: '工厂登录'
          }
        }, {
          path: '/userLogin',
          name: 'userLogin',
          component: resolve => require(['@/view/userLogin'], resolve),
          meta: {
            title: '用户登录'
          }
        }
      ]
    },
    //产品与服务
    {
      path: '/productsAndServices',
      name: 'productsAndServices',
      component: resolve => require(['@/view/productsAndServices'], resolve),
      meta: {
        title: '产品与服务'
      },
    },
    //解决方案
    {
      path: '/solution',
      name: 'solution',
      component: resolve => require(['@/view/solution'], resolve),
      meta: {
        title: '解决方案'
      },
    },
    //实用案例
    {
      path: '/applicationCases',
      name: 'applicationCases',
      component: resolve => require(['@/view/applicationCases'], resolve),
      meta: {
        title: '实用案例'
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js